export default "__VITE_ASSET__9121153a__"